'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _spauiUtils = require('@tencent/spaui-utils');

var _index = require('../utils/index');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Tencent is pleased to support the open source community by making SPA UI available.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               * Copyright (C) 2019, a Tencent company. All rights reserved.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                               */


var NavBarHeader = function (_PureComponent) {
    _inherits(NavBarHeader, _PureComponent);

    function NavBarHeader() {
        _classCallCheck(this, NavBarHeader);

        return _possibleConstructorReturn(this, (NavBarHeader.__proto__ || Object.getPrototypeOf(NavBarHeader)).apply(this, arguments));
    }

    _createClass(NavBarHeader, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                rootUrl = _props.rootUrl,
                logoUrl = _props.logoUrl,
                _props$logoAttribute = _props.logoAttribute,
                logoAttribute = _props$logoAttribute === undefined ? {} : _props$logoAttribute,
                onOpen = _props.onOpen,
                LogoComponent = _props.LogoComponent,
                LogoTitleComponent = _props.LogoTitleComponent,
                _props$titleEvent = _props.titleEvent,
                titleEvent = _props$titleEvent === undefined ? {} : _props$titleEvent,
                _props$logoEvent = _props.logoEvent,
                logoEvent = _props$logoEvent === undefined ? {} : _props$logoEvent;

            var logoDom = null,
                logoTitleDom = null;

            if (typeof LogoComponent !== 'undefined') {
                if ((0, _spauiUtils.isFunction)(LogoComponent)) {
                    logoDom = _react2.default.createElement(
                        LogoComponent,
                        _extends({
                            href: rootUrl,
                            className: 'spaui-topnav-brand logo',
                            type: 'logo'
                        }, (0, _index.getSupportEventMap)(logoEvent)),
                        _react2.default.createElement('img', _extends({ src: logoUrl }, logoAttribute))
                    );
                } else {
                    logoDom = LogoComponent;
                }
            }

            if (typeof LogoTitleComponent !== 'undefined') {
                if ((0, _spauiUtils.isFunction)(LogoTitleComponent)) {
                    logoTitleDom = _react2.default.createElement(
                        LogoTitleComponent,
                        _extends({
                            href: rootUrl,
                            className: 'spaui-topnav-title',
                            type: 'logo-title'
                        }, (0, _index.getSupportEventMap)(titleEvent)),
                        _react2.default.createElement(
                            'span',
                            null,
                            title
                        )
                    );
                } else {
                    logoTitleDom = LogoTitleComponent;
                }
            }

            return _react2.default.createElement(
                'div',
                (0, _spauiUtils.globalProps)(this.props, {
                    className: 'spaui-topnav-header',
                    needTitle: false
                }),
                _react2.default.createElement(
                    'button',
                    {
                        type: 'button',
                        className: 'spaui-topnav-toggler is-collapse',
                        'data-toggle': 'collapse',
                        'data-target': '#std-spaui-topnav',
                        'aria-expanded': 'false',
                        'aria-controls': 'spaui-topnav',
                        onClick: onOpen
                    },
                    _react2.default.createElement(
                        'span',
                        { className: 'spaui-topnav-toggler-icon', title: '\u2630' },
                        _react2.default.createElement('span', { className: 'spaui-topnav-hamb' })
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'spaui-topnav-left' },
                    logoDom,
                    _react2.default.createElement('span', { className: 'spaui-topnav-divider' }),
                    logoTitleDom
                )
            );
        }
    }]);

    return NavBarHeader;
}(_react.PureComponent);

exports.default = NavBarHeader;